import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { ANPD_DISCLAIMER } from '../engine/constants.js';

const TEAL = rgb(23 / 255, 179 / 255, 191 / 255);
const PAPER = rgb(244 / 255, 241 / 255, 247 / 255);
const DARK = rgb(18 / 255, 12 / 255, 22 / 255);
const PANEL = rgb(27 / 255, 20 / 255, 32 / 255);
const GOLD = rgb(232 / 255, 196 / 255, 138 / 255);
const MIST = rgb(217 / 255, 244 / 255, 246 / 255);

function wrap(text, font, size, maxWidth) {
  const words = String(text || '').split(/\s+/).filter(Boolean);
  const lines = [];
  let line = '';
  for (const word of words) {
    const trial = line ? `${line} ${word}` : word;
    if (font.widthOfTextAtSize(trial, size) > maxWidth && line) {
      lines.push(line);
      line = word;
    } else {
      line = trial;
    }
  }
  if (line) lines.push(line);
  return lines;
}

function drawCentered(page, text, font, size, y, color) {
  const tw = font.widthOfTextAtSize(text, size);
  page.drawText(text, { x: (842 - tw) / 2, y, size, font, color });
}

function addDiplomaPage(doc, { title, cert, body, font, fontBold, logo }) {
  const page = doc.addPage([842, 595]);
  page.drawRectangle({ x: 0, y: 0, width: 842, height: 595, color: DARK });
  page.drawRectangle({
    x: 40,
    y: 40,
    width: 762,
    height: 515,
    borderColor: TEAL,
    borderWidth: 3,
    color: PANEL,
  });
  let y = 500;
  if (logo) {
    const w = 140;
    const h = (logo.height / logo.width) * w;
    page.drawImage(logo, { x: (842 - w) / 2, y: y - h, width: w, height: h });
    y -= h + 22;
  }
  drawCentered(page, 'ACADEMIA LGPD ALTEC', fontBold, 11, y, TEAL);
  y -= 28;
  for (const line of wrap(title, fontBold, 20, 680)) {
    drawCentered(page, line, fontBold, 20, y, PAPER);
    y -= 26;
  }
  y -= 8;
  drawCentered(page, cert.learnerName, fontBold, 28, y, PAPER);
  y -= 28;
  drawCentered(page, cert.learnerEmail, font, 14, y, MIST);
  y -= 28;
  drawCentered(page, `Score: ${cert.scoreLabel}`, font, 16, y, PAPER);
  y -= 22;
  drawCentered(page, `Versão ${cert.version}`, font, 13, y, MIST);
  y -= 22;
  const when = new Date(cert.issuedAt).toLocaleString('pt-BR');
  drawCentered(page, when, font, 13, y, MIST);
  y -= 32;
  for (const line of wrap(body, font, 12, 640)) {
    drawCentered(page, line, font, 12, y, PAPER);
    y -= 16;
  }
  y -= 16;
  for (const line of wrap(ANPD_DISCLAIMER, fontBold, 12, 640)) {
    drawCentered(page, line, fontBold, 12, y, GOLD);
    y -= 16;
  }
}

export async function buildCertificatePdf({ cert, course, logoBytes, trilha }) {
  const doc = await PDFDocument.create();
  doc.setTitle(`Certificado · ${course.certName}`);
  doc.setAuthor('Academia LGPD Altec');
  const font = await doc.embedFont(StandardFonts.TimesRoman);
  const fontBold = await doc.embedFont(StandardFonts.TimesRomanBold);
  let logo = null;
  if (logoBytes && logoBytes.byteLength) {
    logo = await doc.embedPng(logoBytes);
  }
  addDiplomaPage(doc, {
    title: course.certName,
    cert,
    body: course.certBody,
    font,
    fontBold,
    logo,
  });
  if (trilha) {
    addDiplomaPage(doc, {
      title: 'Trilha Academia LGPD Altec',
      cert: trilha,
      body: 'Trilha completa: Escudo Estelar, Cofre Quântico e Rede Nebulosa.',
      font,
      fontBold,
      logo,
    });
  }
  return doc.save();
}
